export default __webpack_public_path__ + "static/mean-dsn-days-desktop-1-9f4ade8de518fe42e0cc9b7fbcbfe7d1.svg";